import { isHeightEllipsisActive } from "../../../util/checkTruncate.js";
import { debounce } from "../../../util/dom";
var megaSlider = {};
megaSlider.slider = function () {
  var slider = $(".js-mega-slider");
  if (slider.length === 0) {
    return;
  }
  $.each(slider, function () {
    var $slider = $(this);
    var flkty = $slider.flickity({
      cellAlign: "left",
      contain: true,
      prevNextButtons: true,
      wrapAround: false,
      pageDots: false,
      dragThreshold: 10,
      fullscreen: true,
      on: {
        ready: function ready() {
          var fullscreenButton = $slider.find(".js-btn-fullscreen");
          fullscreenButton.click(function () {
            flkty.flickity("viewFullscreen");
          });
          setTimeout(function () {
            flkty.flickity("resize");
          }, "1000");
        }
      }
    });
  });
};
megaSlider.checkTruncate = function () {
  document.querySelectorAll(".mega-slider-item-content-text").forEach(function (el) {
    el.classList.remove("is-truncated");
    if (isHeightEllipsisActive(el)) {
      el.classList.add("is-truncated");
    }
  });
};
window.addEventListener("resize", debounce(function () {
  megaSlider.checkTruncate();
}, 200));
megaSlider.slider();
megaSlider.checkTruncate();
window.megaSlider = megaSlider;


// WEBPACK FOOTER //
// ./scripts/components/sliders/interstellar/mega-slider.js